"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { commonFormFields, commonValidationRules } from "@/libs/builder/common/formFields";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const formSelectInputs = [
  ...commonFormFields,
  ...commonValidationRules,
  {
    name: "dropdownValues",
    type: "list",
    defaultValue: [
      {
        label: "Option 1",
        value: "option-1",
      },
      {
        label: "Option 2",
        value: "option-2",
      },
    ],
    subFields: [
      {
        name: "label",
        type: "string",
        required: true,
      },
      {
        name: "value",
        type: "string",
        required: true,
      },
    ],
    required: true,
  },
] as const satisfies Inputs;

export const FormSelectComponent: RegisteredComponent = {
  name: "FormSelect",
  component: dynamic(async () =>
    withValidation(formSelectInputs, (await import("./FormSelect")).FormSelect, "FormSelect")
  ),
  inputs: formSelectInputs,
};
